import React from "react";
import {Provider} from "react-redux";
import '../../App.css'
import AppRouter from "../routes/AppRoutes";

export const HOME = '/';

const App = ({ store }) => (
    <Provider store={store}>
        {/*<Preloader>*/}
        {/*    <SetCursor/>*/}
            <AppRouter/>
        {/*</Preloader>*/}
    </Provider>
)
export default (App);